// --lara-light-green-100: #caf1d8;
// --lara-light-green-200: #a0e6ba;
// --lara-light-green-300: #76db9b;
// --lara-light-green-400: #4cd07d;
// --lara-light-green-500: #22c55e;
// --lara-light-green-600: #1da750;
// --lara-light-green-700: #188a42; // HSP THEME GREEN
// --lara-light-green-800: #136c34;
// --lara-light-green-900: #0e4f26;

export const appearance = {
  variables: {
    // colorBackground: "#caf1d8",
    colorForeground: "#1A1523",
    colorPrimary: "#1da750",
    colorPrimaryForeground: "#ffffff",
    colorSecondary: "#F3F3F3",
    colorSecondaryForeground: "#1A1523",
    colorCounter: "#E5484D",
    colorCounterForeground: "white",
    colorNeutral: "black",
    fontSize: "inherit",
    borderRadius: "0.375rem",
  },
  elements: {
    notificationListNewNotificationsNotice__button: {
      background: "#1da750",
    },
    notificationListContainer: {
      paddingRight: "10px",
    },
    inboxHeader: {
      padding: "8px 16px",
    },
    inboxStatus__dropdownTrigger: {
      gap: "2px",
    },
    moreActionsContainer: {
      marginRight: "-4px",
    },
    inboxStatus__title: {
      fontSize: "14px",
      fontWeight: "500",
    },
    notificationImage: {
      borderRadius: "50%",
      width: "24px",
      height: "24px",
    },
    notificationDot: {
      marginTop: "2px",
      backgroundColor: "#1da750",
    },
    notificationSubject: {
      fontFamily: "Inter, sans-serif",
      color: "#188a42",
      fontSize: "17px",
      fontWeight: "600",
      textDecoration: "underline",
    },
    notificationBody: {
      fontFamily: "Inter, sans-serif",
    },
    notificationPrimaryAction__button: {
      variant: "outline",
      paddingLeft: "8px",
      paddingRight: "8px",
      height: "26px",
      borderRadius: "4px",
      border: "0.5px solid #dfdfdf",
      fontWeight: "500",
      backgroundColor: "transparent",
      color: "black",
      fontSize: "14px",
    },
    notificationSecondaryAction__button: {
      variant: "outline",
      paddingLeft: "8px",
      paddingRight: "8px",
      height: "26px",
      borderRadius: "4px",
      border: "0.5px solid #dfdfdf",
      fontWeight: "500",
      backgroundColor: "transparent",
      color: "black",
      fontSize: "14px",
    },
    inboxContent: {
      boxShadow:
        "rgba(15, 15, 15, 0.04) 0px 0px 0px 1px, rgba(15, 15, 15, 0.03) 0px 3px 6px, rgba(15, 15, 15, 0.06) 0px 9px 24px",
      width: "414px",
      backgroundColor: "#fff",
    },
  },
};
